import { t } from 'i18next';
import { FC, ReactElement, useContext } from 'react';
import { Trans } from 'react-i18next';

import { TicketContext } from '../../contexts/TicketContext';
import { startChat } from '../../services/ChatService';
import { ActionContainer } from '../ActionContainer/ActionContainer';
import Button from '../Button/Button';
import { Tag } from '../Tag/Tag';
import style from './ChatLink.module.scss';

const ChatLink: FC = (): ReactElement | null => {
  const { ticket } = useContext(TicketContext);

  if (!ticket) {
    return null;
  }

  return (
    <ActionContainer bgClassName={style.containerBG}>
      <img alt="whatsapp" height={64} src="/assets/blue_callouts.png" width={64} />

      <div className={style.content}>
        <div className={style.headerRow}>
          <span className={style.header}>{t('contact:chatWithSF')}</span>
          <Tag
            icon={<img alt={t('contact:fastest')} height={14} src="/assets/quick_watch.png" />}
            text={t('contact:fastest')}
          />
        </div>

        <p className={style.p}><Trans>{t('contact:chatWithSFDescription')}</Trans></p>
        <Button
          onClick={startChat}
          text={t('contact:startChat')}
        />
      </div>
    </ActionContainer>
  );
};

export default ChatLink;
